// Currency + date formatting helpers (French)
export const euro = (n) => {
  const v = Number(n || 0);
  return `${v.toFixed(2).replace(".", ",")} €`;
};

export const euroPlain = (n) => Number(n || 0).toFixed(2).replace(".", ",");

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 604800) return `il y a ${Math.floor(diff / 86400)} j`;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
};

export const dateTime = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const initials = (name = "") =>
  name.trim().slice(0, 2).toUpperCase();

// Message de compression vidéo renvoyé par le serveur (ffmpeg) : « 33,1 Mo → 0,7 Mo »
export const compressionHint = (info) => {
  if (!info || !info.compressed || !info.original_size || !info.compressed_size) return "";
  const mo = (n) => (n / 1e6).toFixed(1).replace(".", ",") + " Mo";
  const pct = Math.round(100 - (info.compressed_size / info.original_size) * 100);
  return `Vidéo allégée : ${mo(info.original_size)} → ${mo(info.compressed_size)} (-${pct} %)`;
};
